<script setup>
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const { t } = useI18n()

function goBack() {
  router.go(-1)
}
</script>

<template>
  <div
    class="flex flex-col items-center justify-center w-screen h-screen bg-white dark:bg-gray-800"
  >
    <div class="text-bold text-4xl">{{ t('error.title') }}</div>
    <div class="text-semibold text-xl">
      {{ t('error.pageNotFound') }}
      <span class="text-bold text-xl">{{ t('error.notFound') }}</span>
    </div>
    <button
      @click="goBack"
      class="bg-primary-btn p-2 m-5 rounded text-gray-800 text-xl"
    >
      {{ t('buttons.goBack') }}
    </button>
  </div>
</template>
